module.exports = __webpack_public_path__ + "img/earth.2883b478.jpg";